import { getFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import classNames from 'classnames/bind';
import withStyles from 'lib/enhancers/withStyles';
import compose from 'lib/enhancers/compose';
import styles from './EpisodeDetail.module.scss';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { useDictionary } from 'lib/utils';

import type { RecordOfFields } from 'models/fields';
import type { EpisodeTranscriptDetailProps } from 'models/podcasts-types';
import Icon from 'components/helpers/Icon';

const cx = classNames.bind(styles);

const EpisodeDetail = (props: EpisodeTranscriptDetailProps): React.JSX.Element => {
  const { className, fields } = props;
  const { episode, episodePageUrl } = fields;

  const kalturaCode = episode.kalturaMediaID.value;
  const kalturaPlayerTypeItemField = episode.kalturaPlayerType?.fields as RecordOfFields;
  const kalturaPlayerTypeValue = getFieldValue<string>(kalturaPlayerTypeItemField, 'playerID') || '';
  const kalturaPlayerIsVideo = getFieldValue<boolean>(kalturaPlayerTypeItemField, 'isVideoPlayer');
  const playerId = 'video_id_' + kalturaCode;

  React.useEffect(() => {
    const scriptk = document.createElement('script');

    scriptk.src =
      'https://cdnapisec.kaltura.com/p/6105852/embedPlaykitJs/uiconf_id/' +
      kalturaPlayerTypeValue +
      '?autoembed=true&targetId=' +
      playerId +
      '&entry_id=' +
      kalturaCode;

    scriptk.type = 'text/javascript';
    scriptk.async = true;

    const existing = document.querySelector(`script[src="${scriptk.src}"]`);
    if (existing) {
      existing.remove();
    }

    document.body.appendChild(scriptk);
  }, [kalturaCode, playerId, kalturaPlayerTypeValue]);

  return (
    <div>
      <div className={cx('back-to-episode-wrapper')}>
        <a href={episodePageUrl} className={cx('back-to-episode-link', className)}>
          <Icon variant="carat" />
          {useDictionary('Back to Full Episode')}
        </a>
      </div>
      <div>
        {kalturaCode != '' && (
          <div
            className={cx('responsive_padding', kalturaPlayerIsVideo ? 'video-padding' : 'audio-padding', className)}
          >
            <div className={cx('responsive_wrapper', 'video-wrapper')}>
              <div id={playerId} style={{ width: '100%', height: '100%' }}></div>
            </div>
          </div>
        )}
      </div>
      <Text field={{ value: useDictionary('Transcript') }} tag="h3" className={cx({ title: true })} />
      <RichTextWrapper field={episode.transcript} tag="div" className={cx('transcript-text')} />
    </div>
  );
};

export default compose<EpisodeTranscriptDetailProps>(withStyles())(EpisodeDetail);
